<template>
    <client-page>
        <sub-visual subTab sh="About us" index="03" total="04" tabActive="조직도" bg="/images/sub/visual/sv1.jpg"> </sub-visual>

        <section class="section section--first section--last">
            <v-container>
                <div class="tit-wrap">
                    <h2 class="tit tit--lg dot-tit">조직도</h2>
                </div>

                <v-img width="100%" src="/images/sub/aboutus/ko-organization-img.png" class="d-none d-md-block" />
                <v-img width="100%" src="/images/sub/aboutus/ko-organization-m-img.png" class="d-md-none" />
            </v-container>
        </section>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/ko/templates/ClientPage.vue";
import SubVisual from "@/components/client/ko/sub/sub-visual.vue";
export default {
    components: {
        ClientPage,
        SubVisual,
    },
};
</script>

<style lang="scss" scoped></style>
